var map = {
	"./gallery_00.jpg": 2021,
	"./gallery_01.jpg": 2022,
	"./gallery_02.jpg": 2023,
	"./gallery_03.jpg": 2024,
	"./gallery_04.jpg": 2025,
	"./gallery_05.jpg": 2026,
	"./gallery_06.jpg": 2027,
	"./gallery_07.jpg": 2028,
	"./gallery_08.jpg": 2029,
	"./gallery_09.jpg": 2030
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2020;